import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Cookies from 'universal-cookie';
import { handleResponseCode } from '../../../../../app/utilities/helpers';
import GetProxy from '../../../../../app/GetProxy';


const proxy = GetProxy();
const cookies = new Cookies();

export const dataImportList = createAsyncThunk(
  "post/dataImportList",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(`${proxy}/dataImport/schedulersDetailsList/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return data;
    } catch (error) {
      throw error;
    }
  }
);

export const dataImportSave = createAsyncThunk("post/dataImportSave", async (props) => {
  try {
    const { savePayload, userName } = props;
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    const response = await fetch(
      `${proxy}/triggerSave/${userName}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(savePayload),
      }
    );
    handleResponseCode(response);

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
});
export const Servicegroupdropdown = createAsyncThunk("get/Servicegroupdropdown", async (props) => {
  try {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    const response = await fetch(
      `${proxy}/architectureCompliance/getAwsGroupServiceList`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": Apitoken,
          USERNAME: User,
        },
      }
    );
    handleResponseCode(response);

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
});

export const dataImportGetById = createAsyncThunk("get/dataImportGetById", async (props) => {
  const id = props;
  const Apitoken = cookies.get("apitoken");
  const User = cookies.get("username");
  const res = await fetch(`${proxy}/getById/${id}`, {
    method: "GET",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "DTOP-API-TOKEN": Apitoken,
      USERNAME: User,
    },
  }).then((resp) => resp.json());
  handleResponseCode(res);
  return res;
});

export const changeDataStatus = createAsyncThunk("put/dataImportGetById", async (props) => {
  const { id, status, userName } = props;
  const Apitoken = cookies.get("apitoken");
  const User = cookies.get("username");
  const res = await fetch(`${proxy}/dataImportStatusUpdate/${id}/${status}/${userName}`, {
    method: "PUT",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "DTOP-API-TOKEN": Apitoken,
      USERNAME: User,
    },
  }).then((resp) => resp.json());
  handleResponseCode(res);
  return res;
});

export const dataImportDelete = createAsyncThunk("DELETE/dataImportDelete", async (props) => {
  try {
    const { id, userName } = props;
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    const response = await fetch(
      `${proxy}/delete/${id}`,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": Apitoken,
          USERNAME: User,
        },
      }
    );
    handleResponseCode(response);

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
});
export const ModuleListApi = createAsyncThunk(
  "post/ModuleListApi",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/getModuleNames`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          }
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);


const initialState = {
  tableDILoading: false,
  listTableDIData: [],
  tableCountDILoading: false,
  listTableDataDICount: [],
  tableDIDeleteReload: false,
  tableDISaveReload: false,
  tableStatusReload: false,
  saveDILoader: false,
  getDILoader: false,
  deleteDILoader: false,
  ModuleLoading:false,
  ModuleList:[]
};
export const DataImportConfigSlice = createSlice({
  name: 'DataImportConfigSlice',
  initialState: initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder

      .addCase(dataImportList.pending, (state, action) => {
        state.tableDILoading = true;
      })
      .addCase(dataImportList.fulfilled, (state, action) => {
        state.listTableDIData = action.payload;
        state.tableDILoading = false;
        state.tableDIDeleteReload = false;
        state.tableDISaveReload = false;
        state.tableStatusReload = false;
      })
      .addCase(dataImportList.rejected, (state, action) => {
        state.tableDILoading = false;
      })

      .addCase(dataImportDelete.pending, (state, action) => {
        state.deleteDILoader = true;
      })
      .addCase(dataImportDelete.fulfilled, (state, action) => {
        state.tableDIDeleteReload = true;
        state.tableDISaveReload = false;
        state.tableStatusReload = false;
        state.deleteDILoader = false;
      })
      .addCase(dataImportSave.pending, (state, action) => {
        // state.tableDIDeleteReload = false;
        //state.tableDISaveReload = true;
        state.saveDILoader = true;
      })
      .addCase(dataImportSave.fulfilled, (state, action) => {
        state.tableDIDeleteReload = false;
        state.tableDISaveReload = true;
        state.tableStatusReload = false;
        state.saveDILoader = false;
      })
      .addCase(dataImportSave.rejected, (state, action) => {
        // state.tableDIDeleteReload = false;
        // state.tableDISaveReload = true;
        state.saveDILoader = false;
      })
      .addCase(changeDataStatus.fulfilled, (state, action) => {
        state.tableDIDeleteReload = false;
        state.tableDISaveReload = false;
        state.tableStatusReload = true;
      })
      .addCase(dataImportGetById.pending, (state, action) => {
        state.getDILoader = true;
      })
      .addCase(dataImportGetById.fulfilled, (state, action) => {
        state.getDILoader = false;
      })
      .addCase(dataImportGetById.rejected, (state, action) => {
        state.getDILoader = false;
      })

      //ModuleListApi
            .addCase(ModuleListApi.pending, (state, action) => {
              state.ModuleLoading = true;
            })
            .addCase(ModuleListApi.fulfilled, (state, action) => {
              state.ModuleList = action.payload;
              state.ModuleLoading = false;
            })
            .addCase(ModuleListApi.rejected, (state, action) => {
              state.ModuleLoading = false;
              state.ModuleList = [];
            });

  },

});
export const { } = DataImportConfigSlice.actions;
export default DataImportConfigSlice.reducer;